import { ForwardSurvey } from '@hotjar/webapp/features/Surveys/ForwardSurvey';
import type { ForwardSurveyProps } from '@hotjar/webapp/features/Surveys/ForwardSurvey';

export type IntegrationsSectionProps = ForwardSurveyProps;

export const IntegrationsSection = (props: IntegrationsSectionProps): JSX.Element => {
  return <ForwardSurvey {...props} />;
};
